import React, { useEffect, useState } from 'react';

import { Card } from '@material-ui/core';
import i18n from 'i18n-js';

import { OrderUpdateModel } from 'api/models';
import { OrderStatus, OrderServices, OrderItemStatus } from 'constants/enums';
import { OrderDetails } from 'store/ordersStore/reducer';
import { useStyles } from '../styles';
import { statusColor, statusText } from 'constants/arrays';
import { useAppSelector } from 'index';

export default function OrderStatusItem(props: {
    update: any;
    order: OrderDetails;
    isDisabled: boolean;
}) {
    const classes = useStyles();
    const user = useAppSelector((state) => state.user);
    const [showSelect, setShowSelect] = useState(false);

    function changeStatus(status: OrderStatus) {
        let model: OrderUpdateModel = {
            orderItems: props.order.orderItems,
            deliveryTime: props.order.deliveryTime,
            status: status,
            paymentMethod: props.order.paymentMethod,
            qrCodeName: props.order.qrCodeName,
            service: props.order.service,
        };
        if (status === OrderStatus.Ready) {
            model.orderItems = model.orderItems.map((x) => ({
                ...x,
                status: OrderItemStatus.Ready,
            }));
        } /* else if (status === OrderStatus.Closed) {
            model.orderItems = model.orderItems.map((x) => ({
                ...x,
                status: OrderItemStatus.Closed,
            }));
            model.status = OrderStatus.Closed;
        } */ else if (
            status === OrderStatus.Delivery &&
            props.order.service === OrderServices.HomeDelivery
        ) {
            model.status = status;
        }

        setShowSelect(false);
        props.update(model);
    }
    // should be refactored by using OutsideClickHandler for example
    const isOpen = () => document.getElementById('status-change-select')?.style.display !== 'none';

    function handleClick(e: any) {
        /* e.stopPropagation();
        e.preventDefault(); */
        e.target.slot !== 'status-container' && isOpen() && setShowSelect(false);
    }

    function prepareStatusStyle() {
        if (props.order.status === OrderStatus.Cancelled) {
            return {
                border: `1px solid ${statusColor[props.order.status]}`,
                color: statusColor[props.order.status],
            };
        } else if (
            !props.order.isPaid &&
            props.order.orderItems.every((item) => item.status === OrderItemStatus.Delivered)
        ) {
            return { backgroundColor: statusColor[9] };
        } else {
            return { backgroundColor: statusColor[props.order.status] };
        }
    }

    function prepareStatusesList() {
        let list = [];
        /* switch (props.status) {
            case OrderStatus.New:
                list.push(
                    <div
                        className={classes.orderDetailsHeadingBackground}
                        style={{
                            backgroundColor: statusColor[1],
                        }}
                        onClick={() => changeStatus(OrderStatus.InProgress)}
                        key={statusColor[1]}
                    >
                        {statusText[1]}
                    </div>
                );
                break;
            case OrderStatus.InProgress:
                list.push(
                    <div
                        className={classes.orderDetailsHeadingBackground}
                        style={{
                            backgroundColor: statusColor[2],
                        }}
                        onClick={() => changeStatus(OrderStatus.Ready)}
                        key={statusColor[2]}
                    >
                        {statusText[2]}
                    </div>
                );
                break;
            case OrderStatus.Ready:
                list.push(
                    <div
                        className={classes.orderDetailsHeadingBackground}
                        style={{
                            backgroundColor: statusColor[3],
                        }}
                        onClick={() =>
                            //temporary disable payment checking, need to clarify flow for this
                            //props.order.paymentMethod !== PaymentMethod.None &&
                            //props.order.isPaid &&
                            props.order.paymentMethod !== PaymentMethod.None &&
                            changeStatus(OrderStatus.Closed)
                        }
                        key={statusColor[3]}
                    >
                        {statusText[3]}
                    </div>
                );
                break;
        } */
        if (props.order.status === OrderStatus.Ready) {
            if (props.order.service === OrderServices.HomeDelivery) {
                list.push(
                    <div
                        className={classes.orderDetailsHeadingBackground}
                        style={{
                            backgroundColor: statusColor[4],
                        }}
                        onClick={() => changeStatus(OrderStatus.Delivery)}
                        key={statusColor[7]}
                    >
                        {statusText[4]}
                    </div>
                );
            } else if (props.order.isPaid) {
                if (
                    props.order.service !== OrderServices.DineIn ||
                    (props.order.service === OrderServices.DineIn &&
                        props.order.orderItems.every(
                            (item) => item.status === OrderItemStatus.Delivered
                        ) &&
                        props.order.responsibleUserId === user.authUserId)
                ) {
                    list.push(
                        <div
                            className={classes.orderDetailsHeadingBackground}
                            style={{
                                backgroundColor: statusColor[OrderStatus.Closed],
                            }}
                            onClick={() => changeStatus(OrderStatus.Closed)}
                            key={statusColor[OrderStatus.Closed]}
                        >
                            {statusText[OrderStatus.Closed]}
                        </div>
                    );
                } else {
                    list.push(
                        <div
                            className={classes.orderDetailsHeadingBackground}
                            style={{
                                color: statusColor[6],
                                border: `1px solid ${statusColor[OrderStatus.Cancelled]}`,
                                marginTop: list.length > 0 ? 10 : 0,
                            }}
                            onClick={() => changeStatus(OrderStatus.Cancelled)}
                            key={statusColor[6]}
                        >
                            {i18n.t(`common.statusText.${OrderStatus.Cancelled}`)}
                        </div>
                    );
                }
            }
        }
        if (
            props.order.status === OrderStatus.Delivery ||
            (props.order.status === OrderStatus.Ready &&
                props.order.orderItems.every(
                    (item) =>
                        (item.isPaid && item.status === OrderItemStatus.Delivered) ||
                        item.status === OrderItemStatus.Storno
                ) &&
                props.order.responsibleUserId === user.authUserId)
        ) {
            list.push(
                <div
                    className={classes.orderDetailsHeadingBackground}
                    style={{
                        backgroundColor: statusColor[5],
                    }}
                    onClick={() => changeStatus(OrderStatus.Closed)}
                    key={statusColor[8]}
                >
                    {statusText[OrderStatus.Closed]}
                </div>
            );
        }
        if (props.order.status !== OrderStatus.Cancelled && !props.order.isPaid) {
            list.push(
                <div
                    className={classes.orderDetailsHeadingBackground}
                    style={{
                        color: statusColor[6],
                        border: `1px solid ${statusColor[OrderStatus.Cancelled]}`,
                        marginTop: list.length > 0 ? 10 : 0,
                    }}
                    onClick={() => changeStatus(OrderStatus.Cancelled)}
                    key={statusColor[6]}
                >
                    {i18n.t(`common.statusText.${OrderStatus.Cancelled}`)}
                </div>
            );
        }

        return list;
    }

    useEffect(() => {
        document.body.addEventListener('click', (e) => handleClick(e));
        return () => {
            document.body.addEventListener('click', (e) => handleClick(e));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.order.status]);
    return (
        <div
            className={`${classes.orderHeaderItem} ${classes.flexColumnSpaceBetween} ${
                classes.orderStatus
            } ${showSelect && classes.orderHeaderItemActive}`}
            onClick={() => {
                if (!props.isDisabled && prepareStatusesList().length > 0) {
                    setShowSelect(!showSelect);
                }
            }}
            style={{ cursor: !props.isDisabled ? 'pointer' : 'auto' }}
            slot="status-container"
        >
            <div className={classes.orderDetailsHeadingText} slot="status-container">
                {i18n.t('common.status')}
            </div>
            <div
                className={classes.orderDetailsHeadingBackground}
                style={prepareStatusStyle()}
                slot="status-container"
            >
                {i18n.t(`common.statusText.${props.order.status}`)}
            </div>
            <Card
                slot="status-container"
                className={classes.changeStatusDropdown}
                id="status-change-select"
                style={{
                    display: !props.isDisabled && showSelect ? 'flex' : 'none',
                }}
            >
                {prepareStatusesList()}
            </Card>
        </div>
    );
}
